var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-with-line",style:({ marginTop: _vm.nowStyle + 'px' })},[_c('span',{staticClass:"box-with-line-text"},[_vm._v(_vm._s(_vm.boxText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }